import { render, staticRenderFns } from "./OnbngWelcome.vue?vue&type=template&id=5c917d6c&scoped=true"
import script from "./OnbngWelcome.vue?vue&type=script&lang=js"
export * from "./OnbngWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c917d6c",
  null
  
)

export default component.exports